import React, { Suspense, lazy } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import games from '../games/manifest';
import './GameWrapper.css';

export default function GameWrapper() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useLanguage();

  const gameEntry = games.find((g) => g.id === id);

  if (!gameEntry) {
    return (
      <div className="game-wrapper">
        <div className="game-wrapper-content">
          <p>{t('game.notFound')}</p>
          <button className="btn btn-secondary" onClick={() => navigate('/')}>{t('game.back')}</button>
        </div>
      </div>
    );
  }

  const GameComponent = lazy(gameEntry.loader);

  return (
    <div className="game-wrapper">
      <header className="game-wrapper-header">
        <button className="btn-back" onClick={() => navigate('/')}>
          &#8592; {t('game.back')}
        </button>
        <h2>{t(gameEntry.titleKey)}</h2>
        {gameEntry.mechanic && (
          <span className="game-wrapper-mechanic">{t(`mechanic.${gameEntry.mechanic}`)}</span>
        )}
      </header>
      <div className="game-wrapper-content">
        <Suspense fallback={<div className="game-loading">{t('game.loading')}</div>}>
          <GameComponent />
        </Suspense>
      </div>
    </div>
  );
}
